import React from 'react';
import FormContact from '../partials/FormContact';
import API from '../../configAPI';
import Pasarelab from '../Pasarela/Pasarela_c';
class Shopping extends React.Component{
        constructor(props){
        super(props);
        this.state = {
            providers: {
                data: [],
                current_page: 1,
                total: 0,
                last_page: 1
            },
            distritos:{
                data:[],
            },
            totalproduc: JSON.parse(localStorage.getItem('total_car')) ? JSON.parse(localStorage.getItem('total_car')) : [] ,
            listaCarrito: JSON.parse(localStorage.getItem('Carrito')) ? JSON.parse(localStorage.getItem('Carrito')) : [] ,
            total_prec: JSON.parse(localStorage.getItem('total_prec')) ? JSON.parse(localStorage.getItem('total_prec')) : [] ,
            total_envio: JSON.parse(localStorage.getItem('total_envio')) ? JSON.parse(localStorage.getItem('total_envio')) : [] ,
            total_pago: JSON.parse(localStorage.getItem('total_pago')) ? JSON.parse(localStorage.getItem('total_pago')) : [] ,
            name_distrito:localStorage.getItem('name_distrito') ? localStorage.getItem('name_distrito') : [] ,
            distrito_id:localStorage.getItem('distrito_id') ? localStorage.getItem('distrito_id') : [] ,
            enviado:localStorage.getItem('enviado') ? localStorage.getItem('enviado') : 0 ,
            text_query: '',
            distrito:0,
            loading: true,

            full_name:'',
            email:'',
            phone_number:'',
            message:'',   
            message_serve:''  
        }

    }
    handleChange=(e)=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }
    componentDidMount(){
        this.getDistritos();
        window.scrollTo(0,0);
    }
     getDistritos = () => {
        API.PRODUCTS(`distritos`)
         .then(resp =>{
             this.setState({
                 distritos : resp.data,
                 loading: !this.state.loading
             });
 
         })
         .catch(err =>{
             this.setState({
                 loading: !this.state.loading
             });
             console.log(err);
         });
     }
     handleChange=(e)=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }
     formCard=(e)=>{
        this.setState({loading:true});
        e.preventDefault();
        API.PRODUCTS.post('contact-card',{
            carrito:this.state.listaCarrito,
            full_name:this.state.full_name,
            phone_number:this.state.phone_number,
            email:this.state.email,
            message:this.state.message
        })
        .then(resp=>{
            this.setState({
                message_serve:resp.data.message,
                loading:false,
                enviado:2,
                   
            })
            localStorage.setItem("enviado",2);
            this.vaciarcard();
            
            
        })
        .catch(err => {
            this.setState({loading:false});
            console.log(err);
        })
     }
     calcularEnvio= (e) => {
        this.setState({loading:true});
        e.preventDefault();
        API.PRODUCTS.post(`calcular/envio`,{
            carrito:this.state.listaCarrito,
            distrito:this.state.distrito,
        })
         .then(resp =>{
             this.setState({
                listaCarrito : resp.data ,
                 loading: false,
              
                
             });
             localStorage.setItem("Carrito",JSON.stringify(resp.data));

             var total=0;
             var total_envio=0;
             var total_pago=0;
             var Null=0;
             var NR=0;
         var precio=0;
            for(let numero in this.state.listaCarrito){
                this.state.name_distrito=this.state.listaCarrito[numero].distrito;
                localStorage.setItem("name_distrito",this.state.name_distrito);

                this.state.distrito_id=this.state.listaCarrito[numero].distrito_id;
                localStorage.setItem("distrito_id",this.state.distrito_id);

                if(Number(this.state.listaCarrito[numero].descuento)>0){
                    precio= this.state.listaCarrito[numero].fair_precio;
                }else{
                  precio=this.state.listaCarrito[numero].precio;
                }
                total = total + (this.state.listaCarrito[numero].cantidad * precio);

                if(this.state.listaCarrito[numero].envio=="Null"){
                    Null=Null + 1;
                }else if( this.state.listaCarrito[numero].envio=="NR"){
                   NR=NR+1;
                }else{
                    total_envio= total_envio + Number(this.state.listaCarrito[numero].envio);
                }
            }
            if(Null>0){
                localStorage.setItem("total_envio",-2);
                localStorage.setItem("total_pago",-2);
                total_envio=-2;
                total_pago=-2;
            }else if(NR>0){
                localStorage.setItem("total_envio",-1);
                localStorage.setItem("total_pago",-1);
                total_envio=-1;
                total_pago=-1;
                
            }else{
                localStorage.setItem("total_envio",total_envio);
                total_pago= total + total_envio;
                localStorage.setItem("total_pago",total_pago);

            }
                localStorage.setItem("total_prec",total);
                this.setState({total_prec: total,total_envio:total_envio,total_pago:total_pago});
                
                window.location.href = window.location.href;
 
         })
         .catch(err =>{
             this.setState({
                 loading: false
             });
             console.log(err);
         });
     }

    
    
     
  

    render(){
        return(
            
            <div className="row col-md-12 col-xs-12">   
           { (this.state.totalproduc != 0) ? 
           
           <div className="row col-md-12 col-xs-12">  

            <div className="col-md-9 col-xs-12">
            <h6 className="text-center">Envio a: {this.state.name_distrito} </h6>
            <p className="text-center" ><a type="button" className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Cambiar Distrito</a></p>
                <table className="table">
                <thead>
                    <tr>
                    <th>Producto</th>
                    <th style={{width:"15%"}}>Precio unitario</th>
                    <th style={{width:"10%"}}>Cantidad</th>
                    <th style={{width:"15%"}}>Precio</th>
                    <th style={{width:"2%"}}></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.listaCarrito.map((prod,index) =>(
                        <tr id={"td_car"+prod.id} key={index}>
                        <td >
                            <div className="product_car">
                                <div className="img">
                                    <a href={'producto/'+prod.slug}><img src={prod.img.props.src} width="100%"></img></a>
                                   
                                </div>

                                <div className="text">
                                    <h5>{prod.titulo}</h5>
                                    <p style={{fontWeight:"700"}}>{prod.proveedor}</p>
                                    {prod.descuento>0?
                                    <span style={{color:"#009c02",fontWeight:"700"}}><span className="descuento_pd">- {prod.descuento} %</span> ahorras: S/. {(prod.precio-prod.fair_precio).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>
                                    : ""
                                    }
                                     <p className="envio"><i className="fas fa-motorcycle"></i> envío: {prod.envio=="Null"?<a type="button" className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>: prod.envio=="NR"?<span className="noregistrado">No registrado</span>:prod.envio==0.00?<span className="gratis">GRATIS</span> :<span className="envio">S/. {prod.envio}</span>}</p>
                                    <p className="envio"><i className="far fa-clock"></i> Entrega Estimada: {prod.dias=="Null"?<a type="button" className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>:prod.dias=="NR"?<span className="noregistrado">No registrado</span>:prod.dias==1?<span className="envio"> {prod.dias} día.</span>:<span className="envio"> {prod.dias} días.</span>}</p>
                                </div>
                            </div>
                        </td>
                    <td ><p id={"card_precio" + prod.id}>
                        <span className="precio_prod">S/.{prod.descuento>0? prod.fair_precio.toLocaleString(navigator.language, { minimumFractionDigits: 2 }):prod.precio.toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span>

                        <span className="fair_precio_prod">{prod.descuento>0?"S/. "+prod.precio.toLocaleString(navigator.language, { minimumFractionDigits: 2 }):""}</span>
                    </p></td>
                        <td><input className="input-shopping" id={"card_cantidad" + prod.id} onChange={this.editarcantidad.bind(this,prod.id,index,prod.precio,prod.fair_precio,prod.descuento,prod.cantidad,prod.stock,prod.envio)} type="number" defaultValue={prod.cantidad} style={{width:"100%"}} min="1" max={prod.stock}></input></td>
                    
                    <td ><p style={{fontWeight:"700"}} id={"card_tprecio" + prod.id}>S/.{prod.descuento>0?(prod.cantidad*prod.fair_precio).toLocaleString(navigator.language, { minimumFractionDigits: 2 }):(prod.cantidad*prod.precio).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</p></td>
                        
                        <td><button onClick={this.eliminarcard.bind(this,prod.id,index)} className="eliminar-list"><i className="far fa-trash-alt "></i></button></td>
                        </tr>
                        ))}
                    
                </tbody>
                </table>
                <a href="/productos" style={{fontWeight:"700"}}> <i className="fas fa-chevron-left"></i> Continuar comprando</a>
            </div>

            <div className="col-md-3 col-xs-12 res_pedido">
                <h3>Resumen del pedido</h3>
                <p style={{fontWeight:"700",color:"#535353"}}>Subtotal<span style={{float:"right"}} id="total_prec">S/. {JSON.parse(localStorage.getItem('total_prec'))==null?0:JSON.parse(localStorage.getItem('total_prec')).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span></p>
                <hr/>
                <p style={{fontWeight:"700",color:"#535353"}}>Gastos de envío<span style={{float:"right"}} id="total_envio"> {localStorage.getItem('total_envio')==null?<a type="button"  className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>:JSON.parse(localStorage.getItem('total_envio'))==-1?<span className="noregistrado">No se puede calcular</span>:JSON.parse(localStorage.getItem('total_envio')==-2)? <a type="button"  className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>:"S/. " + JSON.parse(localStorage.getItem('total_envio')).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span></p>

                
                <hr/>
               
                <p style={{fontWeight:"700",color:"#535353"}}>Total<span style={{float:"right"}} id="total_pago"> {localStorage.getItem('total_pago')==null?<a type="button"  className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>:JSON.parse(localStorage.getItem('total_envio'))==-1?<span className="noregistrado">No se puede calcular</span>:JSON.parse(localStorage.getItem('total_pago')==-2)? <a type="button"  className="btn btn-primary calcular" data-toggle="modal" data-target="#exampleModal">Calcular</a>:"S/. " + JSON.parse(localStorage.getItem('total_pago')).toLocaleString(navigator.language, { minimumFractionDigits: 2 })}</span></p>

                
                            {this.state.loading === false &&
                                <Pasarelab
                                   amount={this.state.total_prec}
                                   envio={this.state.total_envio}
                                   carrito={this.state.listaCarrito}
                                
                                />
                            }

                            <div className="row mt-4">
                                <section className="col-12">
                                 
                                <div className="row">
                                    
                                <div className="col-sm-12 col-xs-12">
                                    <div className="card">
                                    <div className="card-body">
                                    {this.state.message_serve!==''&&
                                    <div className="alert alert-success">{this.state.message_serve}</div>
                                    }
                                    <h4 className="text-center">Contactar con un Asesor</h4> 
                                        <p style={{color:"#6C6C6C"}}>¿Tienes necesidades particulares?, puedes enviar tu carrito de compra a un asesor de ventas para que se pueda comunicar contigo.</p>
                                        <form id="formCard" onSubmit={this.formCard}>
                                        <div className="mb-3">
                                            <label  className="form-label">Nombres</label>
                                            <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" required></input>
                                            
                                        </div>
                                        <div className="mb-3">
                                            <label  className="form-label">Email</label>
                                            <input type="email" onChange={this.handleChange} className="form-control" name="email" id="correo"  required></input>
                                            
                                        </div>
                                        <div className="mb-3">
                                            <label className="form-label">Teléfono</label>
                                            <input type="number" onChange={this.handleChange} className="form-control"  id="telf" name="phone_number" required></input>
                                        </div>

                                        <div className="mb-3">
                                        <div className="form-floating">
                                        <label >Mensaje</label>
                                        <textarea className="form-control" onChange={this.handleChange} placeholder="Escribir mensaje ...." id="mensaje" name ="message" required defaultValue={this.state.message} style={{height: "100px"}}></textarea>
                                        
                                        </div>
                                        </div>

                                        <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input" id="check" required/>
                                        <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}> Al marcar ésta casilla acepto la <a type="button" className="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModal1"> Política de protección de datos personales</a> . </label>              
                                        </div>
                                        <div className="form-group form-check">
                                        <input type="checkbox" className="form-check-input" id="check" required/>
                                        <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
                                        </div>
                        



                                        <button type="submit" className="btn btn-primary" style={{width:"100%"}}>Enviar</button>
                                        </form>
                                    </div>
                                    </div>
                                </div>
                               
                                
                                </div>
                                </section>
                             </div>


                        <div className="row mt-4">
                                <section className="col-12">
                                <h4 className="text-center">¿Tienes dudas o consultas?</h4>  
                                <div className="row">
                                    
                                <div className="col-sm-12 col-xs-12">
                                    <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Escríbenos por Whatsapp</h5>
                                        <a className="card-text" href="https://api.whatsapp.com/send?phone=51981324180&amp;text=Hola%20quisiera%20informaci%C3%B3n%20sobre%20" style={{color:"#6C6C6C"}}  ><i className="fab fa-whatsapp"></i> 981 324 180</a>
                                        
                                    </div>
                                    </div>
                                </div>
                               
                                <div className="col-sm-12 col-xs-12" style={{marginTop:"7px"}}>
                                    <div className="card">
                                    <div className="card-body">
                                        <h5 className="card-title">Escríbenos por email</h5>
                                        <a className="card-text" href="mailto:info@arquiproductos.com" style={{color:"#6C6C6C"}} ><i className="far fa-envelope"></i> info@arquiproductos.com</a>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                </section>
                             </div>
                <button className="vaciar-carrito" onClick={this.vaciarcard.bind(this)}><i className="far fa-trash-alt"></i> Vaciar Carrito</button>      
            </div>
            
            </div>
            :
                                    
      
                            
            this.state.enviado>0?
           
            <div className="col-md-10 mx-auto">
            <p className="p-tienda">Su solicitud de compra ah sido enviada con éxito . Para más compras le invitamos a dar un paseo por nuestra <a href="/productos">Tienda Virtual</a></p>
            <p className="p-correo">te hemos enviado un correo con todo los detalles.</p>   
            <img src="/assets/carrito-compras.jpeg" width="50%" style={{marginLeft:"25%"}}></img>
             </div>
            :                    
            <div className="col-md-10 mx-auto">
                <p className="p-tienda">No ha agregado productos al carrito de compras. Lo invitamos a dar un paseo por nuestra <a href="/productos">Tienda Virtual</a></p>
                <img src="/assets/carrito-compras.jpeg" width="50%" style={{marginLeft:"25%"}}></img>
            </div>
            }
            
            

           
        



<div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" >
  <div className="modal-dialog modal-sm">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">Calcular Envío</h5>
        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <form id="calcular" onSubmit={this.calcularEnvio}>
        <div className="mb-3">
                <label  className="form-label">Departamento</label>
                <select className="form-control" defaultValue="1">
                    <option value="">LIMA</option>
                </select>
                                            
            </div>
            <div className="mb-3">
                <label  className="form-label">Provincia</label>
                <select className="form-control" defaultValue="1">
                    <option  value="">LIMA</option>
                </select>
                                            
            </div>
            <div className="mb-3">
                <label  className="form-label">Distrito</label>
                
                <select className="form-control"   onChange={this.handleChange} name="distrito" required defaultValue="0">
                <option value="0"> SELECCIONE </option>
                {this.state.distritos.data.map((dist,index) =>(  
                     <option  value={dist.id} key={index}>{dist.nombre}</option>
                ))}
                </select>
                                  
            </div>
            <div className="mb-3">
            <div className="card">
                <div className="card-body" style={{color:"red"}}>
                    "Si su distrito no se encuentra en esta lista puede contactarse con un asesor rellenando el formulario"
                </div>
</div>
            </div>

                                        
            <button type="submit" className="btn btn-primary" style={{width:"100%"}}>Calcular</button>
        </form>
      </div>
      {/*<div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>*
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>*/}
    </div>
  </div>
</div>

            </div>
        )
    }
    eliminarcard = (id,index) =>{
        console.log(index);
        

            
            this.state.listaCarrito.splice(index,1);


       var listaCarrito = this.state.listaCarrito;
                
            localStorage.setItem("Carrito",JSON.stringify(listaCarrito));

         this.state.totalproduc = Number(this.state.totalproduc) - 1 ;
         localStorage.setItem("total_car",this.state.totalproduc);
         document.querySelector("#total_product").innerHTML = localStorage.getItem("total_car");

        
         //document.querySelector("#td_car"+id).style.display = "none";
         localStorage.removeItem("total"+id);

         


         var total=0;
         var precio=0;
            for(let numero in this.state.listaCarrito){
                if(Number(this.state.listaCarrito[numero].descuento)>0){
                    precio= this.state.listaCarrito[numero].fair_precio;
                }else{
                  precio=this.state.listaCarrito[numero].precio;
                }
                total = total + (this.state.listaCarrito[numero].cantidad * precio);
            }
                localStorage.setItem("total_prec",total);
                //document.querySelector("#total_prec").innerHTML ="S/. "+ total + ".00";
                this.setState({total_prec: total,
                listaCarrito:listaCarrito});
            
            localStorage.setItem("total_pago",-2);
            localStorage.setItem("total_envio",-2);        
               // window.location.reload(true);
    }

    editarcantidad = (id,index,precio,fair_precio,descuento,cantidad,stock,envio) =>{

        var card_cantidad = document.querySelector("#card_cantidad"+id).value;
        
        
        if (Number(card_cantidad) <=0) {
            alert('Seleccione una cantidad válida');
            document.querySelector("#card_cantidad"+id).value=cantidad;

            this.state.listaCarrito[index].cantidad=1;
            var listaCarrito=this.state.listaCarrito;
            localStorage.setItem("Carrito",JSON.stringify(listaCarrito));
            return
        }
        
        if(Number(stock) < Number(card_cantidad)){
            alert('Máxima existencia es: '+ stock);
            document.querySelector("#card_cantidad"+id).value=cantidad;

            this.state.listaCarrito[index].cantidad=stock;
            var listaCarrito=this.state.listaCarrito;
            localStorage.setItem("Carrito",JSON.stringify(listaCarrito));
        }else{
        

        if(Number.isInteger(Number(card_cantidad))){
            var precio_prod = 0;
            if(descuento>0){
                precio_prod=fair_precio;
            }else{
                precio_prod=precio;
            }
            var total_prec =document.querySelector("#total_prec"+id);
            document.querySelector("#card_tprecio"+id).innerHTML="S/. "+(card_cantidad*precio_prod).toLocaleString(navigator.language, { minimumFractionDigits: 2 });
            
            this.state.listaCarrito[index].cantidad=Number(card_cantidad);
            var listaCarrito=this.state.listaCarrito;
            localStorage.setItem("Carrito",JSON.stringify(listaCarrito));

            
            var total=0;
            var total_envio=0;
            var total_pago=0;
            var Null=0;
            var NR=0;
        var precio=0;
           for(let numero in this.state.listaCarrito){
               if(Number(this.state.listaCarrito[numero].descuento)>0){
                   precio= this.state.listaCarrito[numero].fair_precio;
               }else{
                 precio=this.state.listaCarrito[numero].precio;
               }
               total = total + (this.state.listaCarrito[numero].cantidad * precio);
    
               if(this.state.listaCarrito[numero].envio=="Null"){
                   Null=Null + 1;
               }else if( this.state.listaCarrito[numero].envio=="NR"){
                  NR=NR+1;
               }else{
                   total_envio= total_envio + Number(this.state.listaCarrito[numero].envio);
               }
           }
           if(Null>0){
               localStorage.setItem("total_envio",-2);
               localStorage.setItem("total_pago",-2);
               total_envio=-2;
               total_pago=-2;
           }else if(NR>0){
               localStorage.setItem("total_envio",-1);
               localStorage.setItem("total_pago",-1);
               total_envio=-1;
               total_pago=-1;
               
           }else{
               localStorage.setItem("total_envio",total_envio);
               total_pago= total + total_envio;
               localStorage.setItem("total_pago",total_pago);
    
           }
               localStorage.setItem("total_prec",total);
               this.setState({total_prec: total,total_envio:total_envio,total_pago:total_pago});


        }else{
            alert("Seleccione un número entero");
            document.querySelector("#card_cantidad"+id).value=cantidad;
        }
        
        }
        
       

    }

    vaciarcard = () =>{

        for(let numero in this.state.listaCarrito){
            localStorage.removeItem("total"+this.state.listaCarrito[numero].id);
        }

        

        localStorage.removeItem("Carrito");
        localStorage.removeItem("name_distrito");
        localStorage.removeItem("distrito_id");
        localStorage.setItem("total_pago",-2);
        localStorage.setItem("total_envio",-2);
        localStorage.setItem("total_prec",0);
        localStorage.setItem("total_car",0);
        document.querySelector("#total_product").innerHTML = 0;
        if(this.state.enviado==2){
            localStorage.setItem("enviado",2);
            this.setState({total_prec: 0,
                listaCarrito:[],
                totalproduc:0,
                enviado:2,
            });
        }else{
            localStorage.setItem("enviado",0);
            this.setState({total_prec: 0,
                listaCarrito:[],
                totalproduc:0,
                enviado:0,
            });
        }
       
        
    }
   

}

export default Shopping;
